module.exports = __webpack_public_path__ + "static/media/EmptyShared.baf93534.svg";